import { i18n } from '@/i18n'

const checkEmail = (rule, value, callback) => {
  if (value === '') {
    callback(new Error(`${i18n.t('customer.rules.email')}`))
  } else {
    const mailformat = /^\w+([\\.+-]?\w+)*@\w+([\\.+-]?\w+)*(\.\w{1,10})+$/
    if (value.match(mailformat)) {
      callback()
    } else {
      callback(new Error(`${i18n.t('customer.rules.email_invalid')}`))
    }
  }
}

const checkNumber = (rule, value, callback) => {
  if (value === '') {
    callback(new Error(i18n.t('discount.rules.input_required')))
  } else if (value == '0') {
    callback(new Error(i18n.t('discount.rules.input_not_zero')))
  } else {
    callback()
  }
}

export const rulesSyncBlibli = {
  id: [{
    required: true,
    message: i18n.t('store_list_page.rules.store_id'),
    trigger: 'blur',
  }],
  api: [{
    required: true,
    message: i18n.t('store_list_page.rules.api_password'),
    trigger: 'blur',
  }],
}

export const rulesSyncZalora = {
  id: [{
    required: true,
    message: i18n.t('store_list_page.rules.client_id'),
    trigger: 'blur',
  }],
  secret: [{
    required: true,
    message: i18n.t('store_list_page.rules.client_secret'),
    trigger: 'blur',
  }],
  warehouse: [{
    required: true,
    message: i18n.t('store_list_page.rules.master_warehouse'),
    trigger: 'change',
  }],
  shipment: [{
    required: true,
    message: i18n.t('store_list_page.rules.arrange_shipment'),
    trigger: 'change',
  }],
}

export const rulesWarehouseBlibli = {
  warehouse: [{
    required: true,
    message: i18n.t('store_list_page.rules.main_warehouse'),
    trigger: 'change',
  }],
  pickup: [{
    required: true,
    message: i18n.t('store_list_page.rules.channel_warehouse'),
    trigger: 'change',
  }],
}

export const rulesDistributor = {
  name: [{
    required: true,
    message: i18n.t('distributor.rules.name'),
    trigger: 'blur',
  }],
  product_categories: [{
    type: 'array',
    required: true,
    message: i18n.t('distributor.rules.categories'),
    trigger: 'change',
  }],
  email: [{
    required: true,
    validator: checkEmail,
    trigger: 'blur',
  }],
  phone_number: [{
    required: true,
    message: i18n.t('distributor.rules.phone_number'),
    trigger: 'blur',
  }],
  taxid: [{
    required: true,
    message: i18n.t('distributor.rules.taxid'),
    trigger: 'blur',
  }],
  taxname: [{
    required: true,
    message: i18n.t('distributor.rules.taxname'),
    trigger: 'blur',
  }],
  bank_name: [{
    required: true,
    message: i18n.t('distributor.rules.bank_name'),
    trigger: 'change',
  }],
  account_number: [{
    required: true,
    message: i18n.t('distributor.rules.account_number'),
    trigger: 'blur',
  }],
  account_name: [{
    required: true,
    message: i18n.t('distributor.rules.account_name'),
    trigger: 'blur',
  }],
  sla_complain_day: [{
    required: true,
    message: i18n.t('distributor.rules.sla_shipping_day'),
    trigger: 'blur',
  }],
  city: [{
    required: true,
    message: i18n.t('distributor.rules.city'),
    trigger: 'blur',
  }],
  district: [{
    required: true,
    message: i18n.t('distributor.rules.district'),
    trigger: 'blur',
  }],
  postal_code: [{
    required: true,
    message: i18n.t('distributor.rules.postal_code'),
    trigger: 'blur',
  }],
  street: [{
    required: true,
    message: i18n.t('distributor.rules.address'),
    trigger: 'blur',
  }],
  warehouse_name: [{
    required: true,
    message: i18n.t('distributor.rules.warehouse_name'),
    trigger: 'blur',
  }],
  warehouse_coverage: [{
    required: true,
    message: i18n.t('distributor.rules.coverage'),
    trigger: 'blur',
  }],
  warehouse_city: [{
    required: true,
    message: i18n.t('distributor.rules.city'),
    trigger: 'blur',
  }],
  warehouse_district: [{
    required: true,
    message: i18n.t('distributor.rules.district'),
    trigger: 'blur',
  }],
  warehouse_postal_code: [{
    required: true,
    message: i18n.t('distributor.rules.postal_code'),
    trigger: 'blur',
  }],
  warehouse_street: [{
    required: true,
    message: i18n.t('distributor.rules.address'),
    trigger: 'blur',
  }],
}

export const rulesBank = {
  bank_id: [{
    required: true,
    message: 'Bank harus dipilih',
    trigger: 'change',
  }],
  account_number: [{
    required: true,
    message: 'No. Rekening harus diisi, harus mengandung setidaknya 7 karakter',
    trigger: 'blur',
    min: 7,
  }],
  account_name: [{
    required: true,
    message: 'Nama Akun harus diisi, harus mengandung setidaknya 3 karakter',
    trigger: 'blur',
    min: 3,
  }],
}

export const rulesRequest = {
  bank: [{
    required: true,
    message: 'Bank harus dipilih',
    trigger: 'change',
  }],
  amount: [{
    required: true,
    validator: checkNumber,
    trigger: 'change',
  }],
  correct: [{
    type: 'array',
    required: true,
    message: 'Data sesuai harus dipilih',
    trigger: 'change',
  }],
}

export const rulesPriceArea = {
  price_area_id: [{
    required: true,
    message: 'Area harus dipilih',
    trigger: 'change',
  }],
  customer_category_id: [{
    required: true,
    message: 'Tipe Pelanggan harus dipilih',
    trigger: 'change',
  }],
  value: [{
    required: true,
    message: 'Harga harus diisi',
    trigger: 'blur',
  }],
  uom: [{
    required: true,
    message: 'Satuan harus dipilih',
    trigger: 'change',
  }],
  effective_date: [{
    required: true,
    message: 'Tanggal Berlaku harus dipilih',
    trigger: 'change',
  }],
}

export const rulesPromotion = {
  min: [{
    required: true,
    validator: checkNumber,
    trigger: 'blur',
  }],
  max: [{
    required: true,
    validator: checkNumber,
    trigger: 'blur',
  }],
  uom: [{
    required: true,
    message: i18n.t('discount.rules.uom_required'),
    trigger: 'change',
  }],
}

export const rulesGift = {
  value_type: [{
    required: true,
    message: i18n.t('discount.rules.discount_format_required'),
    trigger: 'change',
  }],
  value: [{
    required: true,
    validator: checkNumber,
    trigger: 'blur',
  }],
  max_value: [{
    required: true,
    validator: checkNumber,
    trigger: 'blur',
  }],
  currency: [{
    required: true,
    message: i18n.t('discount.rules.currency_required'),
    trigger: 'change',
  }],
  qty: [{
    required: true,
    validator: checkNumber,
    trigger: 'blur',
  }],
  uom: [{
    required: true,
    message: i18n.t('discount.rules.uom_required'),
    trigger: 'change',
  }],
  catalog_id: [{
    required: true,
    message: i18n.t('discount.rules.product_required'),
    trigger: 'change',
  }],
}

export const rulesVoucher = {
  code: [{
    required: true,
    message: i18n.t('discount.rules.voucher_code_required'),
    trigger: 'blur',
  }],
  start_until: [{
    required: true,
    message: i18n.t('discount.rules.start_date_required'),
    trigger: 'change',
  }],
  end_until: [{
    required: true,
    message: i18n.t('discount.rules.end_date_required'),
    trigger: 'change',
  }],
}

export const rulesDiscount = {
  promotion_name: [{
    required: true,
    message: i18n.t('discount.rules.program_name_required'),
    trigger: 'blur',
  }],
  start_date: [{
    required: true,
    message: i18n.t('discount.rules.start_date_required'),
    trigger: 'change',
  }],
  end_date: [{
    required: true,
    message: i18n.t('discount.rules.end_date_required'),
    trigger: 'change',
  }],
  attribute: [{
    required: true,
    message: i18n.t('discount.rules.promotion_type_required'),
    trigger: 'change',
  }],
  tier: [{
    required: true,
    message: i18n.t('discount.rules.discount_level_required'),
    trigger: 'change',
  }],
  type: [{
    required: true,
    message: i18n.t('discount.rules.program_type_required'),
    trigger: 'change',
  }],
  typePromo: [{
    required: true,
    message: i18n.t('discount.rules.promo_criteria_type_required'),
    trigger: 'change',
  }],
  quota: [{
    required: true,
    trigger: 'blur',
  }],
}

export const rulesAddPriceArea = {
  area_name: [{
    required: true,
    message: 'Nama Harga per Area harus diisi',
    trigger: 'blur',
  }],
}

export const rulesCustomer = {
  email: [{
    required: true,
    validator: checkEmail,
    trigger: 'change',
  }],
  storeName: [{
    required: true,
    message: i18n.t('customer.rules.name'),
    trigger: 'blur',
  }],
  namecustomer: [{
    required: true,
    message: i18n.t('customer.rules.namecustomer'),
    trigger: 'blur',
  }],
  phone: [{
    required: true,
    message: i18n.t('customer.rules.mobile'),
    trigger: 'blur',
  }],
  password: [{
    required: true,
    message: i18n.t('customer.rules.password'),
    trigger: 'change',
  }],
  confirmpassword: [{
    required: true,
    message: i18n.t('customer.rules.confirm_password'),
    trigger: 'blur',
  }],
  category: [{
    required: true,
    message: i18n.t('customer.rules.category'),
    trigger: 'change',
  }],
  line1: [{
    required: true,
    message: i18n.t('customer.rules.road_name_required'),
    trigger: 'blur',
  }],
  country: [{
    required: true,
    message: i18n.t('customer.rules.country_required'),
    trigger: 'blur',
  }],
  city: [{
    required: true,
    message: i18n.t('customer.rules.city_required'),
    trigger: 'blur',
  }],
  subdistrict: [{
    required: true,
    message: i18n.t('customer.rules.subdistrict_required'),
    trigger: 'blur',
  }],
  postcode: [{
    required: true,
    message: i18n.t('customer.rules.postcode_required'),
    trigger: 'blur',
  }],
  city_distributor: [{
    type: 'array',
    required: true,
    message: i18n.t('customer.rules.city'),
    trigger: 'change',
  }],
  distributor: [{
    type: 'array',
    required: true,
    message: i18n.t('customer.rules.distributor'),
    trigger: 'change',
  }],
  sales_code: [{
    required: true,
    message: i18n.t('customer.rules.sales_code'),
    trigger: 'change',
  }],
  coin_usage: [{
    required: true,
    message: i18n.t('customer.rules.coin_usage'),
    trigger: 'change',
  }],
  coin_flag: [{
    required: true,
    message: i18n.t('customer.rules.coin_usage'),
    trigger: 'change',
  }],
  payment_model: [{
    required: true,
    message: i18n.t('customer.rules.payment_model_required'),
    trigger: 'change',
  }],
  credit_limit: [{
    required: true,
    message: i18n.t('customer.rules.credit_limit_required'),
    trigger: 'change',
  }],
}
